import 'twin.macro'

import CheckDoneIcon from 'assets/icons/step-done-check.svg?component'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

import Typography from '../Typography'

type StepProps = {
  step: number
  currentStep: number
  stepsCount: number
  children: string
}

const AppStep = ({ step, stepsCount, currentStep, children }: StepProps) => {
  const { t } = useTranslation()

  return (
    <div tw='flex items-center'>
      <div
        css={[
          tw`flex items-center justify-center h-[34px] w-[34px] rounded-full border-2 border-grey-middle flex-shrink-0`,
          step === currentStep && tw`border-primary-middle`,
          step < currentStep && tw`text-white bg-primary-middle border-primary-middle`
        ]}
      >
        <Typography as='span' weight='bold' twStyle={tw`inline-block`}>
          {step}
        </Typography>
      </div>
      <div tw='ml-3'>
        <Typography variant='caption' twStyle={tw`text-grey-dark`}>
          <Trans
            values={{
              currentStep: step,
              stepsCount
            }}
          >
            {t('steps-text')}
          </Trans>
        </Typography>
        <Typography variant='body' weight='bold'>
          {children}
        </Typography>
      </div>
      {step < currentStep && <CheckDoneIcon tw='ml-auto' />}
    </div>
  )
}

export default AppStep
